import React from "react";
import ReactDOM from "react-dom";
import singleSpaReact from "single-spa-react";

const lifecycles = singleSpaReact({
  React,
  ReactDOM,
  loadRootComponent: async () => (await import("./containers/root-component/root-component")).default,
  errorBoundary(err, info, props) {
    // Customize the root error boundary for your microfrontend here.
    return null;
  }
});

export const { bootstrap, mount, unmount } = lifecycles;

export { useObservable, createObservable } from "./hooks/useobservable/useObservable";
export { default as useTimeFormat } from "./hooks/usetimeformat/useTimeFormat";
export { default as FeatureFlagProvider } from "./hooks/usefeatureflag/featureflagprovider";
export { default as useFeatureFlag } from "./hooks/usefeatureflag/usefeatureflag";
export { default as useLocalStorage } from "./hooks/uselocalstorage/uselocalstorage";
export { default as useToken } from "./hooks/usetoken/usetoken";

export { default as mapSubjectToProduct } from "./helpers/product-subject-mapper";

export { default as BackLink } from "./components/backlink/backlink";
export { default as Search } from "./components/search/search";
export { default as SearchSubmit } from "./components/search-submit/search-submit";
export { default as TabSwitcher } from "./components/tabswitcher/tabswitcher";
export { default as PageTitle } from "./components/pagetitle/pagetitle";
export { default as DashboardCard } from "./components/dashboardcard/dashboardcard";
export { default as HoverToolTip } from "./components/hovertooltip/hovertooltip";
export { default as OverflowTooltip } from "./components/overflow-tooltip/overflow-tooltip";
export { default as LabeledSelect } from "./components/labeledselect/labeledselect";
export { default as MultiSelect } from "./components/multiselect/multiselect";
export { default as LabeledMultiSelect } from "./components/labeled-multi-select/labeled-multi-select";
export { default as SortableLabel } from "./components/sortablelabel/sortablelabel";
export { default as EmptyState } from "./components/emptystate/emptystate";
export { default as PrintButton } from "./components/printbutton/printbutton";
export { default as Loading } from "./components/loading/loading";
export { default as Legends } from "./components/legends/legends";
export { default as Resources } from "./components/lesson-information-modal/resources";
export { default as Details } from "./components/lesson-information-modal/details";
export { default as LessonInformationHeader } from "./components/lesson-information-modal/lesson-information-header";
export { default as EditPlacementModal } from "./components/placement-modal/edit-placement-modal";
export { default as DeactivateModal } from "./components/placement-modal/deactivate-modal";
export { default as LessonTypeBadge } from "./components/lesson-type-badge/lesson-type-badge";
export { default as PathwayTypeBadge } from "./components/pathway-type-badge/pathway-type-badge";
export {
  getStandardCodesForTile,
  getStandardCodes,
  Standard_Click
} from "./components/lesson-information-modal/standards";
export { default as Standard } from "./components/lesson-information-modal/standard";
export { default as LessonInformationModal } from "./components/lesson-information-modal/lesson-information-modal";
export { default as LessonViewerModal } from "./components/lesson-viewer-modal/lesson-viewer-modal";
export { default as EducatorPreviewer } from "./components/educator-content-reader/educator-previewer/educator-previewer";
export { default as EducatorReviewer } from "./components/educator-content-reader/educator-reviewer/educator-reviewer";
export { changeTimeZone as changeTimeZone } from "./helpers/timefunctions";
export { toTime as toTime } from "./helpers/timefunctions";
export { possessive as possessive } from "./helpers/nameformat";
export { default as MpngModal } from "./components/mpngmodal/mpngmodal";
export { default as HoverToast } from "./components/hovertoast/hovertoast";
export { default as MpngExportReport } from "./components/export-report-modal";
export { default as ActivityIndicator } from "./components/activity-indicator/activity-indicator";
export { default as HelpMessage } from "./components/help-message/help-message";
export { secureFetch as secureFetch } from "./helpers/securefetch";
export { default as Tabs } from "./components/tabs/tabs";
export { default as ErrorBox } from "./components/error/error";
export { default as Alert } from "./components/alert/alert";
export { default as AlertToast } from "./components/alert-toast/alert-toast";
export { default as Drawer } from "./components/drawer/drawer";
export { default as FaIcon } from "./components/fa-icon/fa-icon";
export { default as Modal } from "./components/modal/modal";
export { default as LoadingScreen } from "./components/loading-screen/loading-screen";
export { default as Navbar } from "./components/navbar/navbar";
export { default as Action } from "./components/action/action";
export { default as ProductSelector } from "./components/product-selector/product-selector";
export { default as Breadcrumbs } from "./components/breadcrumbs/breadcrumbs";
export { default as PagedNavTable } from "./components/paged-nav-table/paged-nav-table";
export { default as SamplePagedNavTableUsage } from "./components/paged-nav-table/sample-paged-nav-table-usage";
export { default as ClassCard } from "./components/class-card/class-card";
export { default as ReportLinkCard } from "./components/report-link-card/report-link-card";
export { default as Banner } from "./components/banner/banner";
export { default as EducatorLinkPlayer } from "./components/educator-link-player/educator-link-player";
export { default as Filters } from "./components/filters/filters";
export { IconPrint } from "./components/icons";
export { IconCloudDownload } from "./components/icons";
export { IconCloud } from "./components/icons";
export { IconDownload } from "./components/icons";
export { IconCheckSquare } from "./components/icons";
export { IconChevronDown } from "./components/icons";
export { IconSquare } from "./components/icons";
export { IconSearch } from "./components/icons";
export { IconXMark } from "./components/icons";
export { IconClose } from "./components/icons";
export { IconClear } from "./components/icons";
export { IconNotPassed } from "./components/icons";
export { IconCheckCircle } from "./components/icons";
export { IconInfoCircle } from "./components/icons";
export { IconMapPin } from "./components/icons";
export { IconXMarkCircle } from "./components/icons";
export { IconLocation } from "./components/icons";
export { IconCheck } from "./components/icons";
export { IconPassed } from "./components/icons";
export { IconInfoCircleNoFill } from "./components/icons";

export { default as BreadcrumbProps } from "./interfaces/breadcrumbprops";

export { default as sizeenum } from "./enums/size.enum"; //TODO: clean up and use the export below instead
export { default as SizeEnum } from "./enums/size.enum";
export { default as PositionEnum } from "./enums/position.enum";
export { default as SizeExtraEnum } from "./enums/size-extra.enum";
export { default as IconEnum } from "./enums/icon.enum";
export { default as PriorityEnum } from "./enums/priority.enum";
export { default as LanguageEnum } from "./enums/language.enum";
export { default as PathwayTypeEnum } from "./enums/pathway-type.enum";
export { default as LessonTypeEnum } from "./enums/lesson-type.enum";
export { default as OrientationEnum } from "./enums/orientation.enum";
export { default as DirectionEnum } from "./enums/direction.enum";
export { default as IconLibraryEnum } from "./enums/icon-library.enum";
export { default as ReportLinkCardEnum } from "./enums/report-link-card.enum";
export { default as HelpMessageEnum } from "./enums/help-message.enum";
export { default as SubjectEnum } from "./enums/subject.enum";
export { default as ProductEnum } from "./enums/product-enum";

export type { IActivity } from "./components/educator-content-reader/educator-content-reader.props";

export { Languages } from "./components/educator-content-reader/educator-content-reader.props";
